import { useCallback, useState } from 'react';

import { ModalRoot } from '@/components/ui';

import { ModalContext, type ModalOptions } from './ModalContext';

const DEFAULT_OPTIONS: ModalOptions = { size: 'md', closeOnScrim: true };

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [content, setContent] = useState<React.ReactNode>(null);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<ModalOptions>(DEFAULT_OPTIONS);

  const openModal = useCallback((node: React.ReactNode, opts?: ModalOptions) => {
    setContent(node);
    setOptions({ ...DEFAULT_OPTIONS, ...opts });
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <ModalRoot
        open={open}
        onClose={closeModal}
        size={options.size}
        closeOnScrim={options.closeOnScrim}
      >
        {content}
      </ModalRoot>
    </ModalContext.Provider>
  );
}
